import { COMPLIANCE_DATA, OFFICE_HOURS, RESPONSE_TIME } from "../constants/compliance";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {

  return (
    <div id="main-content" className="pt-20" data-testid="contact-page">
      <section className="py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-gray-100 text-center" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Get In Touch
          </h1>
          <p className="text-lg text-gray-400 mb-12 text-center max-w-2xl mx-auto">
            Connect with us to learn more about our mutual fund and SIF distribution services.
          </p>

          <div className="max-w-2xl mx-auto">
            <div>
              <h2 className="text-2xl font-semibold mb-6 text-[#d4af69]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                Contact Information
              </h2>
              
              <div className="space-y-6">
                <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg hover:border-[#d4af69] transition-all">
                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-[#1a1410]/30 rounded-lg">
                      <Mail className="w-6 h-6 text-[#d4af69]" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Email</p>
                      <a href={`mailto:${COMPLIANCE_DATA.contactEmail}`} className="text-gray-200 hover:text-[#d4af69] transition-colors font-medium">
                        {COMPLIANCE_DATA.contactEmail}
                      </a>
                    </div>
                  </div>
                </div>

                <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg hover:border-[#d4af69] transition-all">
                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-[#1a1410]/30 rounded-lg">
                      <Phone className="w-6 h-6 text-[#d4af69]" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Phone</p>
                      <a href={`tel:${COMPLIANCE_DATA.contactPhone}`} className="text-gray-200 hover:text-[#d4af69] transition-colors font-medium">
                        {COMPLIANCE_DATA.contactPhone}
                      </a>
                    </div>
                  </div>
                </div>

                <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg hover:border-[#d4af69] transition-all">
                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-[#1a1410]/30 rounded-lg">
                      <MapPin className="w-6 h-6 text-[#d4af69]" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Address</p>
                      <p className="text-gray-200 font-medium">{COMPLIANCE_DATA.address}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}